import { Component } from "@angular/core";

@Component({
    selector: 'app-notfound',
    templateUrl: './notfound.component.html'
  })
  export class NotFoundComponent {

  }